<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">
            <div class="container-fluid xyz">
                <div class="page-header-top-container">
                    <div class="page-name color-71aa3f">Welcome Customer List</div>
                    <!-- <button id="create"   v-on:click.prevent="addCustomer">+Add</button> -->
                    <div class="btn-group pull-right">
                        <button type="button" class="btn_all_welcome btn general-button btn-primary" v-on:click="allClickWelcomeLetter()">All</button>
                        <button type="button" class="btn_my_welcome btn general-button btn-secondary" v-on:click="myClickWelcomeLetter()">My Self</button>
                    </div>
                    <div class="clearfix"></div>
                    <div class="forms-container mt-3">
                        <div class="row no-margin">
                            <div class=" col-lg-3 col-md-3 col-xs-12 col-sm-12">
                                <label for="totalDue">Search For</label>
                                <select class="form-control show-tick" id="searchFor">
                                    <option value="">Please select</option>
                                    <option value="cusId">CusId</option>
                                    <option value="customerName">Customer Name</option>
                                    <option value="registrationAge">Registration Age</option>
                                    <option value="contactEmail">Contact Email</option>
                                    <option value="contactPhone">Contact Number</option>
                                </select>
                            </div>
                            <div class=" col-lg-3 col-md-3 col-xs-12 col-sm-12" v-show="filterType != ''">
                                <label for="totalDue">Filter type</label>
                                <select class="form-control show-tick" id="totlaDueCondition">
                                    <option value="">Please select</option>
                                    <option value="=">is</option>
                                    <option value=">" v-show="filterType == 'number' || filterType == 'date'">></option>
                                    <option value=">=" v-show="filterType == 'number' || filterType == 'date'">>=</option>
                                    <option value="<" v-show="filterType == 'number' || filterType == 'date'"><</option>
                                    <option value="<=" v-show="filterType == 'number' || filterType == 'date'"><=</option>
                                    <option value="between" v-show="filterType == 'number' || filterType == 'date'">Between</option>
                                    <option value="like" v-show="filterType == 'string'">Like</option>
                                </select>
                            </div>
                            <div class=" col-lg-3 col-md-3 col-xs-12 col-sm-12" v-show="totalDueCondition != ''">
                                <label for="totalDue">Filter</label>
                                <input type="text" class="form-control" placeholder="Enter Data" id="totalDueAmt1"/>
                            </div>
                            <div class=" col-lg-3 col-md-3 col-xs-12 col-sm-12" v-show="totalDueCondition == 'between'">
                                <label for="totalDue">Second Filter</label>
                                <input type="text" class="form-control" placeholder="Enter Data" id="totalDueAmt2"/>
                            </div>
                            <div class="clearfix"></div>
                            <!--<div class="row" v-show="searchFieldName != ''">-->
                            <div class="clearfix col-lg-3 col-md-3 col-xs-12 col-sm-12" v-show="searchFieldName != ''">
                                <label for="totalDue">Search For</label>
                                <select class="form-control show-tick" id="searchFor2">
                                    <option value="">Please select</option>
                                    <option value="cusId">CusId</option>
                                    <option value="customerName">Customer Name</option>
                                    <option value="registrationAge">Registration Age</option>
                                    <option value="contactEmail">Contact Email</option>
                                    <option value="contactPhone">Contact Number</option>
                                </select>
                            </div>
                            <div class=" col-lg-3 col-md-3 col-xs-12 col-sm-12" v-show="filterType2 != ''">
                                <label for="totalDue">Filter type</label>
                                <select class="form-control show-tick" id="totlaDueCondition2">
                                    <option value="">Please select</option>
                                    <option value="=">is</option>
                                    <option value=">" v-show="filterType2 == 'number' || filterType2 == 'date'">></option>
                                    <option value=">=" v-show="filterType2 == 'number' || filterType2 == 'date'">>=</option>
                                    <option value="<" v-show="filterType2 == 'number' || filterType2 == 'date'"><</option>
                                    <option value="<=" v-show="filterType2 == 'number' || filterType2 == 'date'"><=</option>
                                    <option value="between" v-show="filterType2 == 'number' || filterType2 == 'date'">Between</option>
                                    <option value="like" v-show="filterType2 == 'string'">Like</option>
                                </select>
                            </div>
                            <div class=" col-lg-3 col-md-3 col-xs-12 col-sm-12" v-show="totalDueCondition2 != ''">
                                <label for="totalDue">Filter</label>
                                <input type="text" class="form-control" placeholder="Enter Data" id="totalDueAmt3"/>
                            </div>
                            <div class=" col-lg-3 col-md-3 col-xs-12 col-sm-12" v-show="totalDueCondition2 == 'between'">
                                <label for="totalDue">Second Filter</label>
                                <input type="text" class="form-control" placeholder="Enter Data" id="totalDueAmt4"/>
                            </div>
                            <!--</div>-->
                            <div class="clearfix"></div>
                            <!--<div class="row" v-show="searchFieldName2 != ''">-->
                            <div class=" col-lg-3 col-md-3 col-xs-12 col-sm-12" v-show="searchFieldName2 != ''">
                                <label for="totalDue">Search For</label>
                                <select class="form-control show-tick" id="searchFor3">
                                    <option value="">Please select</option>
                                    <option value="cusId">CusId</option>
                                    <option value="customerName">Customer Name</option>
                                    <option value="registrationAge">Registration Age</option>
                                    <option value="contactEmail">Contact Email</option>
                                    <option value="contactPhone">Contact Number</option>
                                </select>
                            </div>
                            <div class=" col-lg-3 col-md-3 col-xs-12 col-sm-12" v-show="filterType3 != ''">
                                <label for="totalDue">Filter type</label>
                                <select class="form-control show-tick" id="totlaDueCondition3">
                                    <option value="">Please select</option>
                                    <option value="=">is</option>
                                    <option value=">" v-show="filterType3 == 'number' || filterType3 == 'date'">></option>
                                    <option value=">=" v-show="filterType3 == 'number' || filterType3 == 'date'">>=</option>
                                    <option value="<" v-show="filterType3 == 'number' || filterType3 == 'date'"><</option>
                                    <option value="<=" v-show="filterType3 == 'number' || filterType3 == 'date'"><=</option>
                                    <option value="between" v-show="filterType3 == 'number' || filterType3 == 'date'">Between</option>
                                    <option value="like" v-show="filterType3 == 'string'">Like</option>
                                </select>
                            </div>
                            <div class=" col-lg-3 col-md-3 col-xs-12 col-sm-12" v-show="totalDueCondition3 != ''">
                                <label for="totalDue">Filter</label>
                                <input type="text" class="form-control" placeholder="Enter Data" id="totalDueAmt5"/>
                            </div>
                            <div class=" col-lg-3 col-md-3 col-xs-12 col-sm-12" v-show="totalDueCondition3 == 'between'">
                                <label for="totalDue">Second Filter</label>
                                <input type="text" class="form-control" placeholder="Enter Data" id="totalDueAmt6"/>
                            </div>
                            <!--</div>-->
                            <div class="clearfix"></div>
                            <div class="mt-3 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <input id="addTaskBtn" type="button" value="Filter" class="btn general-button btn-success" v-on:click="onColumnFilter()" />
                                <input id="addTaskBtn" type="button" value="Reset" class="btn general-button btn-success" v-on:click="reset()"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="admin-page-content">
                    <div class="app-support-ticket-good-table-container">
                        <vue-good-table class="welcomeCustomerList"
                                        ref="welcomeCustomerTable"
                                        mode="remote"
                                        title="Welcome Customers"
                                        @on-page-change="onPageChange"
                                        @on-selected-rows-change="selectionChanged"
                                        @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange"
                                        @on-sort-change="onSortChange"
                                        :totalRows="totalRecords"
                                        :columns="columns"
                                        :rows="rows"
                                        :selectOptions="{
                                        enabled: true,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                        }"
                                        :pagination-options="{
                                        enabled: true,
                                        mode: 'pages',
                                        pageLabel: 'Page',
                                        position: 'bottom',
                                        perPage: serverParams.perPage,
                                        setCurrentPage: serverParams.setCurrentPage,
                                        perPageDropdown: customPerPageArr,
                                        dropdownAllowAll: false,
                                        }"

                                        :search-options="{
                                        enabled: false,
                                        }">
                                        <template slot="pagination-bottom" slot-scope="props">
                                <div class="vgt-wrap__footer crm">
                                    <div  class="row">
                                        <div class="col-sm-12 col-md-2 PerPage">
                                            <v-select title="Select Per Page"
                                                      v-model="serverParams.perPage"
                                                      @change="changedValue"
                                                      @input="changedValueCustomPerPage()"
                                                      name="customPerPage"
                                                      id="customPerPage"
                                                      label="text"
                                                      :clearable="false"
                                                      :searchable="false"
                                                      :filterable="false"
                                                      :options="customPerPageArr"
                                                      placeholder="Select Per Page">
                                            </v-select>
                                        </div>
                                        <div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
                                            <p class="pageRowCount">{{paginationDisplayRows}} of {{totalRecords}}</p>
                                        </div>
                                        <div class="col-sm-12 col-md-6 Pagination">
                                            <ul class="pagination">
                                                <li class="page-item FirstPage" title="First Page">
                                                    <template v-if="Number(serverParams.page) == 1">
                                                        <a class="page-link" href="javascript:void(0)">1</a>
                                                    </template>
                                                    <template v-else>
                                                        <a v-on:click="onPerticularPageClick(1)" class="page-link" href="javascript:void(0)">1</a>
                                                    </template>
                                                </li>
                                                <li class="page-item PreviousPage" title="Previous Page">
                                                    <template v-if="Number(serverParams.page) == 1">
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1"><i class="fa fa-angle-left"></i></a>
                                                    </template>
                                                    <template v-else>
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1" v-on:click="onPerticularPageClick(Number(serverParams.page)-1)" ><i class="fa fa-angle-left"></i></a>
                                                    </template>
                                                </li>
                                                <!--New Implementation-->
                                                <template v-if="pageNumberList() < displayPage">
                                                    <template v-for="(n, index) in pageNumberList()">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClick(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <!--End New Implementation-->
                                                    <template v-if="Number(serverParams.page) <= pageCompare">
                                                        <template v-for="(n, index) in displayPage">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClick(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                    <template v-else-if="Number(serverParams.page) >= (pageNumberList() - (pageCompare-1))">
                                                        <template v-for="(n, index) in pageNumberList()">
                                                            <template v-if="n > (pageNumberList() - displayPage)">
                                                                <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                                <li :title="'Page ' +n" v-on:click="onPerticularPageClick(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                            </template>
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <template v-for="(n, index) in pageNumberList()" v-if="(n >= (Number(serverParams.page) - (pageCompare -1))) && (n <= (Number(serverParams.page) + (pageCompare -1)))">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClick(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                </template>
                                                <li class="page-item NextPage" title="Next Page">
                                                    <template v-if="Number(serverParams.page) == pageNumberList()">
                                                        <a class="page-link" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
                                                    </template>
                                                    <template v-else>
                                                        <a class="page-link" href="javascript:void(0)" v-on:click="onPerticularPageClick(Number(serverParams.page)+1)"><i class="fa fa-angle-right"></i></a>
                                                    </template>
                                                </li>
                                                <li class="page-item LastPage" title="Last Page">
                                                    <template v-if="Number(serverParams.page) == pageNumberList()">
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberList()}}</a>
                                                    </template>
                                                    <template v-else>
                                                        <a v-on:click="onPerticularPageClick(pageNumberList())" class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberList()}}</a>
                                                    </template>
                                                </li>
                                            </ul>
                                        </div>                                
                                        <div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                            <p class="pageJumpLabel">Page : </p>
                                        </div>
                                        <div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                            <input v-model="jumpToPage" type="text" class="form-control form-control-sm" name="jumpToPage" id="jumpToPage" placeholder="Page">
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                <div :key="key">
                                    <div v-if="props.column.field == 'action'">
                                        <template v-for="(permission, index) in permissions">
                                            <button title='Download welcome letter' v-if="permission.name == 'can_download_welcome_letter_pdf'" :class="'btn edit-btn-vvg waves-effect cust_'+props.row.id" v-on:click="downloadPdf(props.row.id)">
                                                    <i class='fa fa-download' aria-hidden="true"></i>
                                            </button>
                                        </template>
                                    </div>
                                    <div v-else class='btn-center-vvg'>
                                        {{props.formattedRow[props.column.field]}}
                                    </div>
                                </div>
                            </template>
                            <div slot="selected-row-actions">
                                <template v-if="permission.name == 'can_download_welcome_letter_pdf'" v-for="(permission, index) in permissions">
                                    <button title='Download all' v-on:click.prevent="downloadSelectedPdfALL" id="allPdf" class="btn general-button btn-success">Download ALL {{totalRecords}}</button>
                                    <button title='Download selected' v-on:click.prevent="downloadSelectedPdf" id="selectedPdf" class="btn general-button btn-success"><!--<i class='material-icons'>file_download</i>-->Download Selected<!--{{selectedRows}}--></button>
                                </template>
                            </div>
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                    </div>
                </div>
            </div>
        </template>
        <app-footer></app-footer>
    </div>
</template>

<script>


    import Vue from 'vue';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import EventBus from '../event-bus';
    Vue.use(VueGoodTable);
    import SessioMixin from '../../mixins/sessionmixin';
    import FrontFooter from '@/components/partials/FrontFooter';

    export default {
        name: "welcomeCustomers",
        mixins: [SessioMixin],
        components: {
            'app-footer': FrontFooter,
        },
        data: () => ({
                displayPage: 7,
                pageCompare: 0,
                paginationDisplayRows: '',
                jumpToPage: 0,
                customPerPageArr: ['25', '50', '100', '200', '500'],

                permissions: [],
                cantAccessPage: true,
                isLoggedIn: false,
                message: 'all',
                flagAll: '',
                firstLoad: 0,

                checked: false,
                totalDueCondition: '',
                searchFieldName: '',
                filterType: '',
                totalDueCondition2: '',
                searchFieldName2: '',
                filterType2: '',
                totalDueCondition3: '',
                searchFieldName3: '',
                filterType3: '',
                columns: [
                    {
                        label: 'Collector',
                        field: 'user_first_name',
                        filterable: true,
                        filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "Collector", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'CusId',
                        field: 'cusid',
                        filterable: true,
                        filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "CusId", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Customer Name',
                        field: 'first_name',
                        filterable: true,
                        filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "Customer Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [],
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Contact Name',
                        field: 'contact_name',
                        filterable: true,
                        filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "Contact Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [],
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Contact Number',
                        field: 'contact_phone',
                        filterable: true,
                        filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "Contact Number", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [],
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Contact Email',
                        field: 'contact_email',
                        filterable: true,
                        filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "Contact Email", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [],
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Registration Age',
                        field: 'reg_age_days',
                        filterable: true,
                        filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "Registration Age", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [],
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Created Date',
                        field: 'excede_created_at',
                        filterable: true,
                        filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "MM-DD-YYYY", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [],
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Updated Date',
                        field: 'excede_updated_at',
                        filterable: true,
                        filterOptions: {
                            enabled: false, // enable filter for this column
                            placeholder: "MM-DD-YYYY", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [],
                            trigger: "enter", //only trigger on enter not on keyup

                        }
                    },
                    {
                        label: 'Action',
                        field: 'action',
                        sortable: false,
                        thClass: 'disable-sorting',
                        filterable: false
                    }

                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 25,
                    setCurrentPage: 1,
                    sort: {
                        field: 'reg_age_days',
                        type: 'asc',
                    },
                },
                recordsCounts: "",
                selectedRows: 0,
            }),

        mounted: function () {
            var self = this;
            $(".removeActive").removeClass('active');
            $("#menuwelcomeletter").addClass('active');
            if (localStorage.getItem("menu_small") == '1') {
                this.menuSmall();
            } else {
                this.menuBig();
            }
            self.jumpToPage = self.serverParams.page;
            self.pageCompare = Math.ceil(self.displayPage / 2);
            $("#jumpToPage").on('keyup', function (e) {
                if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
                    self.jumpToInputPage(self.jumpToPage)
                }
            });
            self.showLoader();

            $("#totlaDueCondition").change(function () {
                self.totalDueCondition = $("#totlaDueCondition").val();
            });
            $("#totlaDueCondition2").change(function () {
                self.totalDueCondition2 = $("#totlaDueCondition2").val();
            });
            $("#totlaDueCondition3").change(function () {
                self.totalDueCondition3 = $("#totlaDueCondition3").val();
            });
            $("#searchFor").change(function () {
                self.searchFieldName = $("#searchFor").val();
                if (self.searchFieldName == "customerName" || self.searchFieldName == "customerType" || self.searchFieldName == "contactName" || self.searchFieldName == "contactEmail" || self.searchFieldName == "contactPhone" || self.searchFieldName == "collector") {
                    self.filterType = 'string';
                } else if (self.searchFieldName == "cusId" || self.searchFieldName == "invoiceAge" || self.searchFieldName == "dueTerms" || self.searchFieldName == "currentDue" || self.searchFieldName == "dueForDays1to30" || self.searchFieldName == "dueForDays31to60" || self.searchFieldName == "dueForDays61to90" || self.searchFieldName == "totalDueAmount") {
                    self.filterType = 'number';
                } else {
                    self.filterType = 'date';
                }
                if (self.searchFieldName == '') {
                    $("#searchFor2").val('');
                    self.searchFieldName2 = self.searchFieldName3 = self.searchFieldName = self.filterType = self.filterType2 = self.filterType3 = self.totalDueCondition = self.totalDueCondition2 = self.totalDueCondition3 = '';
                }
                $("#totlaDueCondition").val('');
                self.totalDueCondition = self.totalDueCondition2 = self.totalDueCondition3 = '';
                $('#totalDueAmt1').val('');
                $('#totalDueAmt2').val('');
            });
            $("#searchFor2").change(function () {
                self.searchFieldName2 = $("#searchFor2").val();
                if (self.searchFieldName2 == "customerName" || self.searchFieldName2 == "customerType" || self.searchFieldName2 == "contactName" || self.searchFieldName2 == "contactEmail" || self.searchFieldName2 == "contactPhone" || self.searchFieldName2 == "collector") {
                    self.filterType2 = 'string';
                } else if (self.searchFieldName2 == "cusId" || self.searchFieldName2 == "invoiceAge" || self.searchFieldName2 == "dueTerms" || self.searchFieldName2 == "currentDue" || self.searchFieldName2 == "dueForDays1to30" || self.searchFieldName2 == "dueForDays31to60" || self.searchFieldName2 == "dueForDays61to90" || self.searchFieldName2 == "totalDueAmount") {
                    self.filterType2 = 'number';
                } else {
                    self.filterType2 = 'date';
                }
                if (self.searchFieldName2 == '') {
                    $("#searchFor3").val('');
                    self.searchFieldName3 = self.searchFieldName2 = self.filterType2 = self.filterType3 = self.totalDueCondition2 = self.totalDueCondition3 = '';
                }
                $("#totlaDueCondition2").val('');
                self.totalDueCondition2 = self.totalDueCondition3 = '';
                $('#totalDueAmt3').val('');
                $('#totalDueAmt4').val('');
            });
            $("#searchFor3").change(function () {
                self.searchFieldName3 = $("#searchFor3").val();
                if (self.searchFieldName3 == "customerName" || self.searchFieldName3 == "customerType" || self.searchFieldName3 == "contactName" || self.searchFieldName3 == "contactEmail" || self.searchFieldName3 == "contactPhone" || self.searchFieldName3 == "collector") {
                    self.filterType3 = 'string';
                } else if (self.searchFieldName3 == "cusId" || self.searchFieldName3 == "invoiceAge" || self.searchFieldName3 == "dueTerms" || self.searchFieldName3 == "currentDue" || self.searchFieldName3 == "dueForDays1to30" || self.searchFieldName3 == "dueForDays31to60" || self.searchFieldName3 == "dueForDays61to90" || self.searchFieldName3 == "totalDueAmount") {
                    self.filterType3 = 'number';
                } else {
                    self.filterType3 = 'date';
                }
                if (self.searchFieldName3 == '') {
                    $("#searchFor3").val('');
                    self.searchFieldName3 = self.filterType3 = self.totalDueCondition3 = '';
                }
                $("#totlaDueCondition3").val('');
                self.totalDueCondition3 = '';
                $('#totalDueAmt5').val('');
                $('#totalDueAmt6').val('');
            });
            self.loadWelcomeCustomers();
//            this.loadWelcomeCustomers();
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }

        },
        beforeMount: function () {
            var app = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                this.isLoggedIn = true;
                app.getPermissions();
            }
        },
        methods: {
            /*customPageChange(customCurrentPage) {
             },
             customPerPageChange() {
             },*/
            changedValue: function (value) {
                /*console.log(value);*/
            },
            jumpToInputPage: function (pageNumber) {
                var self = this;
                var reg = /^\d+$/;
                if (pageNumber <= 0 || pageNumber == '') {
                    pageNumber = 1;
                } else if (pageNumber > self.pageNumberList()) {
                    pageNumber = self.pageNumberList();
                    if (pageNumber <= 0 || pageNumber == '') {
                        pageNumber = 1;
                    }
                } else if (!String(self.jumpToPage).match(reg)) {
                    pageNumber = 1;
                }
                self.onPerticularPageClick(pageNumber);
            },
            onPerticularPageClick: function (pageNumber) {
                var self = this;
                self.serverParams.page = pageNumber;
                self.jumpToPage = pageNumber;
                /* Single Backend Call on page load start */
                if(self.firstLoad != 1 && self.jumpToPage != 1) {
                    self.loadWelcomeCustomers(); 
                } else if(self.firstLoad == 1 && self.jumpToPage >=1) {
                    self.loadWelcomeCustomers();
                }
                /* Single Backend Call on page load end */
            },
            pageNumberList: function () {
                var self = this;
                var totalRecord = self.totalRecords;
                var count = 0;
                for (var i = 0; totalRecord > 0; i++) {
                    totalRecord = totalRecord - self.serverParams.perPage;
                    count++;
                }
                return count;
            },
            changedValueCustomPerPage: function () {
                var self = this;
                /* Single Backend Call on page load start */
                if(self.firstLoad != 1) {
                    self.jumpToInputPage(self.serverParams.page);
                    self.loadWelcomeCustomers();
                }
                /* Single Backend Call on page load end */
            },
            getPermissions: function () {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/user/permission",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.status == 'success') {
                            self.cantAccessPage = false;
                            self.permissions = data.content;
                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = data.build;
                            if (current_build != undefined && current_build == '') {
                                localStorage.setItem("build_version", data.build);
                            } else if (current_build != latest_build) {
                                localStorage.setItem("build_version", data.build);
                                location.reload(true);
                            }
                            if (self.permissions.length > 0) {
                                for (var i = 0; i < self.permissions.length; i++) {
                                    if (self.permissions[i].name == 'can_see_welcome_letter_list') {
                                        self.cantAccessPage = true;
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.cantAccessPage = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }

                });
            },
            downloadSelectedPdf: function (id) {
                //console.log("selected rows", this.$refs['welcomeCustomerTable'].selectedRows)
                var data = this.$refs['welcomeCustomerTable'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['welcomeCustomerTable'].selectedRows[i].id)
                }
                //console.log(use);
                $("#selectedPdf").html('Preparing...');
                $("#selectedPdf").prop('disabled', true);
                $("#allPdf").prop('disabled', true);
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/customer/exportselectedpdf",
                    type: "GET",
                    data: 'ids=' + use,
                    //processData: false,
                    //contentType: false,
                    dataType: 'json',
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    success: function (data) {
                        if (data.status == "success") {
                            $("#selectedPdf").html('Download Selected');
                            $("#selectedPdf").prop('disabled', false);
                            $("#allPdf").prop('disabled', false);
                            self.loadWelcomeCustomers();
                            /*$(".cust_"+id).hide();
                             $(".cust_"+id).parent().html("<a target='_blank' href='"+data.content.web+"'><button class='btn bg-indigo waves-effect'><i class='material-icons'>file_download</i></button></a>");*/
                            window.open(data.content.web);
                        } else {
                            $("#errorMsg").html(data.message);
                            if (data.content.length > 0) {
                                var err = "";
                                for (var i = 0; i < data.content.length; i++) {
                                    err += data.content[i] + "<br>";
                                }
                                $("#errorMsg").html(err);
                            }
                        }
                        self.hideLoader();
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }

                            self.errorMsg = jqXHR.responseJSON.message;
                        }
                        self.hideLoader();
                    }
                });
            },
            downloadSelectedPdfALL: function (id)
            {
                var self = this;
                self.flagAll = 'flagAll_WelcomeLetter';

                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    flag: "welcomeCustomers",
                    messageData: self.message,
                    sort: self.serverParams.sort,
                    totlaDueCondition: self.totalDueCondition,
                    searchFieldName: self.searchFieldName,
                    totalDue1: $('#totalDueAmt1').val(),
                    totalDue2: $('#totalDueAmt2').val(),
                    totlaDueCondition2: self.totalDueCondition2,
                    searchFieldName2: self.searchFieldName2,
                    totalDue3: $('#totalDueAmt3').val(),
                    totalDue4: $('#totalDueAmt4').val(),
                    totlaDueCondition3: self.totalDueCondition3,
                    searchFieldName3: self.searchFieldName3,
                    totalDue5: $('#totalDueAmt5').val(),
                    totalDue6: $('#totalDueAmt6').val(),
                    flagValue: self.flagAll
                };

                this.firstLoad = 1;
                // console.log(self.serverParams.perPage);
                $("#allPdf").html('Preparing...');
                $("#allPdf").prop('disabled', true);
                $("#selectedPdf").prop('disabled', true);
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/list_welcomecustomer",
                    type: "GET",
                    data: fields,
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.rows = data.content.row;
                        if (data.code == '200') {
                            self.loadWelcomeCustomers();
                            // self.rows = data.content.row;
                            // self.totalRecords = data.content.totalRecords;
                            self.flagAll = '';
                            $("#allPdf").html('Download ALL ' + self.totalRecords);
                            $("#allPdf").prop('disabled', false);
                            $("#selectedPdf").prop('disabled', false);
                            window.open(data.content.web);
                        }
                        self.hideLoader();
                    },
                    error: function (jqXHR, exception) {
                        self.rows = data.content.row;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                        self.hideLoader();
                    }
                });

            },
            downloadPdf: function (id) {

                var self = this;
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/customer/exportpdf",
                    type: "GET",
                    data: {custId: id},
                    //processData: false,
                    //contentType: false,
                    dataType: 'json',
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    success: function (data) {
                        if (data.status == "success") {
                            self.loadWelcomeCustomers();
                            /*$(".cust_"+id).hide();
                             $(".cust_"+id).parent().html("<a target='_blank' href='"+data.content.web+"'><button class='btn bg-indigo waves-effect'><i class='material-icons'>file_download</i></button></a>");*/
                            window.open(data.content.web);
                        } else {
                            $("#errorMsg").html(data.message);
                            if (data.content.length > 0) {
                                var err = "";
                                for (var i = 0; i < data.content.length; i++) {
                                    err += data.content[i] + "<br>";
                                }
                                $("#errorMsg").html(err);
                            }
                        }
                        self.hideLoader();
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }

                            self.errorMsg = jqXHR.responseJSON.message;
                        }
                        self.hideLoader();
                    }
                });

            },
            sendMail: function () {

                //console.log("selected rows", this.$refs['welcomeCustomerTable'].selectedRows)
            },
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            //
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadWelcomeCustomers();
            },
            //
            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                this.loadWelcomeCustomers();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                {
                    field: ('first_name');
                    field: ('contact_phone');
                    field: ('contact_email');
                    field: ('contact_name');
                    field: ('collector');
                    field: ('cusid');
                    field:('reg_age_days');
                    field:('excede_created_at');
                }
                this.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;

                if (this.firstLoad == 1 || filters.first_name || filters.contact_name || filters.contact_phone || filters.contact_email
                        || filters.collector || filters.cusid || filters.reg_age_days || filters.excede_created_at) {
                    this.loadWelcomeCustomers();
                }

            },
            selectionChanged() {
                var self = this;
                self.selectedRows = (self.$refs['welcomeCustomerTable'].selectedRows).length;
                /*console.log(self.selectedRows);*/
            },
            //edit rental page
            editRentalRage(params) {
                var self = this;
                self.$router.push("/addrate/" + params.row.id);
            },
            allClickWelcomeLetter: function () {
                var self = this;
                self.message = 'all';
                self.loadWelcomeCustomers();
            },
            myClickWelcomeLetter: function () {
                var self = this;
                self.message = 'my';
                self.serverParams.page = 1;
                self.jumpToPage = 1;
                self.loadWelcomeCustomers();
            },
            onSortChange(params) {
                this.updateParams({
                    sort: {
                        /* type: params.sortType,
                        field: this.columns[params.columnIndex].field, */
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadWelcomeCustomers();
            },

            reset: function () {
                var self = this;
                self.totalDueCondition = self.searchFieldName = self.filterType = self.totalDueCondition2 = self.searchFieldName2 = self.filterType2 = self.totalDueCondition3 = self.searchFieldName3 = self.filterType3 = '';
                $('#totalDueAmt1').val('');
                $('#totalDueAmt2').val('');
                $('#totalDueAmt3').val('');
                $('#totalDueAmt4').val('');
                $('#totalDueAmt5').val('');
                $('#totalDueAmt6').val('');
                $('#searchFor').val('');
                $('#searchFor2').val('');
                $('#searchFor3').val('');
                self.loadWelcomeCustomers();
            },

            loadWelcomeCustomers: function () {
                var self = this;
                //console.log(self.serverParams.page);
                self.serverParams.setCurrentPage = self.serverParams.page;
                if (self.message == 'my') {
                    self.toggleButtons(self.message, 'btn_my_welcome', 'btn_all_welcome');
                } else {
                    self.toggleButtons(self.message, 'btn_all_welcome', 'btn_my_welcome');
                }
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    flag: "welcomeCustomers",
                    messageData: self.message,
                    sort: self.serverParams.sort,
                    totlaDueCondition: self.totalDueCondition,
                    searchFieldName: self.searchFieldName,
                    totalDue1: $('#totalDueAmt1').val(),
                    totalDue2: $('#totalDueAmt2').val(),
                    totlaDueCondition2: self.totalDueCondition2,
                    searchFieldName2: self.searchFieldName2,
                    totalDue3: $('#totalDueAmt3').val(),
                    totalDue4: $('#totalDueAmt4').val(),
                    totlaDueCondition3: self.totalDueCondition3,
                    searchFieldName3: self.searchFieldName3,
                    totalDue5: $('#totalDueAmt5').val(),
                    totalDue6: $('#totalDueAmt6').val(),
                };

                this.firstLoad = 1;
                // console.log(self.serverParams.perPage);
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/list_welcomecustomer",
                    type: "GET",
                    data: fields,
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.rows = data.content.row;
                        if (data.code == '200') {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.showHidePagination("welcomeCustomerList", self.totalRecords);
                            self.jumpToPage = self.serverParams.page;
                            if (data.content.countRecords != "") {
                                self.recordsCounts = data.content.countRecords;
                            }
                        }
                        self.paginationDisplayRows = self.getRecords(self.serverParams.page, self.serverParams.perPage, self.totalRecords);
                        self.hideLoader();
                    },
                    error: function (jqXHR, exception) {
                        self.rows = data.content.row;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                        self.hideLoader();
                    }
                });
            },
            addCustomer() {
                var self = this;
                self.$router.push("/customerform")
            },
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
            }

        }
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/welcomeLetter/WelcomeCustomers.vue